import { FC, useState } from "react";
import Section from "components/kaleido/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/kaleido/long/parts/Headline";
import styled from "styled-components";
import useObserver from "lib/hooks/kaleido/useObserver";

const Staff: FC = () => {
  const [visibleSection, setVisibleSection] = useState<string | null>(null);
  const sectionVisibilityFlags = useObserver(setVisibleSection);
  const isVisible = visibleSection === "staff" || sectionVisibilityFlags["staff"];
  
  return (
    <StyledSection className={`section ${isVisible ? "visible" : "hidden"}`} id="staff">
      <AnchorTarget id="staff" />
      <Headline src={"/image/lp/kaleido/staff/head2.png"} alt="STAFF" />
      <Content>
        <DescriptionWrapper>
          <DescriptionColumn>
            <Title>＜キャスト＞</Title>
            <Description>
              苗木野そら：広橋 涼
              <br />
              レイラ・ハミルトン：大原さやか
              <br />
              ミア・ギエム：西村ちなみ
              <br />
              アンナ・ハート：渡辺明乃
              <br />
              レオン・オズワルド：櫻井孝宏
              <br />
              メイ・ウォン：中原麻衣
              <br />
              マリオン・ベニーニ：折笠富美子
              <br />
              ジョナサン：小桜エツ子
              <br />
              フル・フール：子安武人
              <br />
              ケン・ロビンス：下野 紘
              <br />
              ロゼッタ・パッセル：水橋かおり
              <br />
              カロス・永戸：藤原啓治
              <br />
              サラ・デュポン：久川 綾
              <br />
              ユーリ・キリアン：千葉進歩
              <br />
              キャシー：三石琴乃
              <br />
              ソフィ：沢城みゆき
              <br />
              マッコリー：島涼香
            </Description>
          </DescriptionColumn>
          <DescriptionColumn>
            <Title>＜スタッフ＞</Title>
            <Description>
              企画：GDH・HAL
              <br />
              原案・監督：佐藤順一
              <br />
              シリーズ構成：吉田玲子
              <br />
              音楽：窪田ミナ
              <br />
              キャラクターデザイン
              <br />
              　&総作画監督：渡辺はじめ・追崎史敏
              <br />
              助監督：平池芳正
              <br />
              美術監督：西川淳一郎
              <br />
              色彩設計：國音邦生
              <br />
              ビジュアルコーディネイター：荻原猛夫
              <br />
              ビジュアルアドバイザー：林コージロー
              <br />
              3DCGIディレクター：松浦裕暁
              <br />
              編集：重村建吾・肥田 文
              <br />
              音響監督：鶴岡陽太
              <br />
              アソシエイトプロデューサー：池田東陽
            </Description>
          </DescriptionColumn>
        </DescriptionWrapper>
        <LeftStar src={"/image/lp/kaleido/staff/head_left.png"} alt="左星" />
        <RightStar src={"/image/lp/kaleido/staff/head_right.png"} alt="右星" />
      </Content>
    </StyledSection>
  );
};
export default Staff;

const StyledSection = styled(Section)`
  position: relative;
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
  &.hidden {
    opacity: 0;
  }

  @media screen and (max-width: 460px) {
    margin-bottom: 50px;
  }
  @media screen and (min-width: 461px) {
    margin-bottom: 90px;
  }
  @media screen and (min-width: 661px) {
    margin-bottom: 110px;
  }
  @media screen and (min-width: 961px) {
    width: 90vw;
    margin-bottom: 120px;
  }
  @media screen and (min-width: 1111px) {
    width: 1000px;
    margin-bottom: 140px;
  }
  @media screen and (min-width: 1281px) {
    margin-bottom: 160px;
  }
`;
const Content = styled.div`
  @media screen and (max-width: 960px) {
    padding: 0 8vw;
    font-size: 2vw;
  }
  @media screen and (min-width: 961px) {
    font-size: 12px;
  }
  @media screen and (min-width: 1001px) {
    font-size: 13px;
  }
`;
const DescriptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  background-color: #f8d7e3;
  border-radius: 50px;
  padding: 3vw 7vw;
  
  @media screen and (max-width: 960px) {
    flex-direction: column;
    border-radius: 5vw;
  }
  @media screen and (min-width: 961px) {
    padding: 3vw 1vw;
  }
`;
const DescriptionColumn = styled.div`
  flex: 1;
  max-width: 100%;
  padding: 0 10px;
  text-align: left;

  @media screen and (max-width: 960px) {
    max-width: 100%;
    padding: 2vw;
  }
`;
const Title = styled.h2`
  color: #e5007f;
  font-size: 1.8em;
  margin-bottom: 0.5em;
`;
const Description = styled.p`
  line-height: 2em;
  letter-spacing: 0.2em;
  color: black;
  font-size: 1.5em;
  white-space: pre-wrap;
  text-align: left;

  @media screen and (max-width: 960px) {
    margin-bottom: 4vw;
  }
  @media screen and (min-width: 961px) {
    max-width: 900px;
  }

  & a {
    color: black;
    text-decoration: underline;
  }
`;
const LeftStar = styled.img`
  position: absolute;
  bottom: 0px;
  left: 0%;
  transform: translateX(-50%);
  z-index: 10;
  top: -180px;

  @media screen and (max-width: 300px) {
    top: 15px;
    left: 8vw;
    width: 30px;
  }
  @media screen and (min-width: 301px) {
    top: 15px;
    left: 8vw;
    width: 30px;
  }
  @media screen and (min-width: 351px) {
    top: 18px;
    left: 8vw;
    width: 30px;
  }
  @media screen and (min-width: 401px) {
    top: 22px;
    left: 7vw;
    width: 37px;
  }
  @media screen and (min-width: 501px) {
    top: 26px;
    left: 7vw;
    width: 44px;
  }
  @media screen and (min-width: 601px) {
    top: 33px;
    left: 7vw;
    width: 58px;
  }
  @media screen and (min-width: 701px) {
    top: 40px;
    left: 7vw;
    width: 69px;
  }
  @media screen and (min-width: 801px) {
    top: 45px;
    left: 7vw;
    width: 80px;
  }
  @media screen and (min-width: 901px) {
    top: 45px;
    left: 8vw;
    width: 105px;
  }

  @media screen and (min-width: 961px) {
    top: 48px;
    left: 3vw;
    width: 105px;
  }
  @media screen and (min-width: 1001px) {
    top: 48px;
    left: 3.1vw;
    width: 115px;
  }
  @media screen and (min-width: 1101px) {
    top: 48px;
    left: 50px;
    width: 145px;
  }
  @media screen and (min-width: 1151px) {
    top: 46px;
    left: 30px;
    width: 150px;
  }
  @media screen and (min-width: 1201px) {
    top: 46px;
    left: 10px;
    width: 150px;
  }
  @media screen and (min-width: 1251px) {
    top: 46px;
    left: -10px;
    width: 155px;
  }
  @media screen and (min-width: 1301px) {
    top: 46px;
    left: -40px;
    width: 160px;
  }
  @media screen and (min-width: 1351px) {
    top: 46px;
    left: -55px;
    width: 165px;
  }
  @media screen and (min-width: 1401px) {
    top: 46px;
    left: -70px;
    width: 170px;
  }
  @media screen and (min-width: 1481px) {
    top: 46px;
    left: -120px;
    width: 175px;
  }
  @media screen and (min-width: 1501px) {
    top: 46px;
    left: -120px;
    width: 180px;
  }
  @media screen and (min-width: 1551px) {
    top: 46px;
    left: -150px;
    width: 185px;
  }
  @media screen and (min-width: 1601px) {
    top: 46px;
    left: -160px;
    width: 185px;
  }
  @media screen and (min-width: 1651px) {
    top: 46px;
    left: -190px;
    width: 185px;
  }
  @media screen and (min-width: 1701px) {
    top: 46px;
    left: -200px;
    width: 185px;
  }
  @media screen and (min-width: 1751px) {
    top: 46px;
    left: -230px;
    width: 185px;
  }
  @media screen and (min-width: 1801px) {
    top: 46px;
    left: -260px;
    width: 185px;
  }
  @media screen and (min-width: 1901px) {
    top: 46px;
    left: -300px;
    width: 190px;
  }
  @media screen and (min-width: 2001px) {
    top: 46px;
    left: -350px;
    width: 190px;
  }
  @media screen and (min-width: 2101px) {
    top: 46px;
    left: -400px;
    width: 190px;
  }
  @media screen and (min-width: 2201px) {
    top: 46px;
    left: -450px;
    width: 190px;
  }
  @media screen and (min-width: 2401px) {
    top: 46px;
    left: -530px;
    width: 190px;
  }
  @media screen and (min-width: 2701px) {
    top: 46px;
    left: -680px;
    width: 190px;
  }
  @media screen and (min-width: 3001px) {
    top: 46px;
    left: -800px;
    width: 190px;
  }
`;
const RightStar = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0%;
  transform: translateX(-50%);
  z-index: -1;
  top: -180px;

  @media screen and (max-width: 300px) {
    top: 15px;
    left: 92vw;
    width: 30px;
  }
  @media screen and (min-width: 301px) {
    top: 15px;
    left: 92vw;
    width: 30px;
  }
  @media screen and (min-width: 351px) {
    top: 18px;
    left: 92vw;
    width: 30px;
  }
  @media screen and (min-width: 401px) {
    top: 22px;
    left: 93vw;
    width: 37px;
  }
  @media screen and (min-width: 501px) {
    top: 26px;
    left: 93vw;
    width: 44px;
  }
  @media screen and (min-width: 601px) {
    top: 33px;
    left: 92.8vw;
    width: 58px;
  }
  @media screen and (min-width: 701px) {
    top: 40px;
    left: 92.8vw;
    width: 69px;
  }
  @media screen and (min-width: 801px) {
    top: 45px;
    left: 92.8vw;
    width: 77px;
  }
  @media screen and (min-width: 901px) {
    top: 45px;
    left: 91.8vw;
    width: 105px;
  }

  @media screen and (min-width: 961px) {
    top: 48px;
    left: 87vw;
    width: 105px;
  }
  @media screen and (min-width: 1001px) {
    top: 48px;
    left: 86.9vw;
    width: 115px;
  }
  @media screen and (min-width: 1101px) {
    top: 48px;
    left: 940px;
    width: 145px;
  }
  @media screen and (min-width: 1151px) {
    top: 46px;
    left: 970px;
    width: 150px;
  }
  @media screen and (min-width: 1201px) {
    top: 46px;
    left: 990px;
    width: 150px;
  }
  @media screen and (min-width: 1251px) {
    top: 46px;
    left: 1010px;
    width: 155px;
  }
  @media screen and (min-width: 1301px) {
    top: 46px;
    left: 1030px;
    width: 160px;
  }
  @media screen and (min-width: 1351px) {
    top: 46px;
    left: 1055px;
    width: 165px;
  }
  @media screen and (min-width: 1401px) {
    top: 46px;
    left: 1080px;
    width: 170px;
  }
  @media screen and (min-width: 1481px) {
    top: 46px;
    left: 1120px;
    width: 175px;
  }
  @media screen and (min-width: 1501px) {
    top: 46px;
    left: 1120px;
    width: 180px;
  }
  @media screen and (min-width: 1551px) {
    top: 46px;
    left: 1150px;
    width: 185px;
  }
  @media screen and (min-width: 1601px) {
    top: 46px;
    left: 1160px;
    width: 185px;
  }
  @media screen and (min-width: 1651px) {
    top: 46px;
    left: 1190px;
    width: 185px;
  }
  @media screen and (min-width: 1701px) {
    top: 46px;
    left: 1200px;
    width: 185px;
  }
  @media screen and (min-width: 1751px) {
    top: 46px;
    left: 1240px;
    width: 185px;
  }
  @media screen and (min-width: 1801px) {
    top: 46px;
    left: 1260px;
    width: 185px;
  }
  @media screen and (min-width: 1901px) {
    top: 46px;
    left: 1310px;
    width: 190px;
  }
  @media screen and (min-width: 2001px) {
    top: 46px;
    left: 1350px;
    width: 190px;
  }
  @media screen and (min-width: 2101px) {
    top: 46px;
    left: 1400px;
    width: 190px;
  }
  @media screen and (min-width: 2201px) {
    top: 46px;
    left: 1440px;
    width: 190px;
  }
  @media screen and (min-width: 2401px) {
    top: 46px;
    left: 1540px;
    width: 190px;
  }
  @media screen and (min-width: 2701px) {
    top: 46px;
    left: 1660px;
    width: 190px;
  }
  @media screen and (min-width: 3001px) {
    top: 46px;
    left: 1800px;
    width: 190px;
  }
`;